// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles-module--footer--2j8xa","left":"styles-module--left--2XX8W","right":"styles-module--right--1rQdA","socialIcon":"styles-module--social-icon--3FEcX"};